const NEW_DAYS = 30;

export const isNew = (p) => !!p?.created_at && Date.now() - new Date(p.created_at).getTime() < NEW_DAYS * 86_400_000;

export const NewBadge = ({ product, className = "" }) =>
  isNew(product) ? <span className={`new-badge ${className}`} data-testid={`new-badge-${product.id}`}>New</span> : null;
